import { formatMoney } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { router, usePage } from '@inertiajs/react';
import { useState } from 'react';

const InvoiceInfoTable = () => {
    const [selected, setSelected] = useState([]);
    const { auth, invoice } = usePage().props;
    const confirm = useConfirmationStore(state => state.confirm);

    const canBeCredited =
        !invoice.is_credit && auth.permissions.includes('update invoices');

    const makrAsCredit = lines => {
        router.patch(
            `/customers/${invoice.customer_id}/invoices/${invoice.id}/mark-as-credit`,
            {
                lines,
            }
        );
    };

    return (
        <>
            {canBeCredited && (
                <div className='mb-4 flex justify-end gap-4'>
                    <Button
                        disabled={selected.length === 0}
                        type='button'
                        onClick={() =>
                            confirm({
                                description:
                                    'Weet u zeker dat u de geselecteerde regels wilt crediteren? Deze actie is niet omkeerbaar. U kunt hierboven ook de volledige factuur crediteren.',
                                onConfirm: close => {
                                    makrAsCredit(selected);
                                    close();
                                },
                            })
                        }
                    >
                        Geselecteerde regels crediteren
                    </Button>
                    <Button
                        type='button'
                        variant='danger'
                        disabled={selected.length > 0}
                        onClick={() =>
                            confirm({
                                description:
                                    'Weet u zeker dat deze factuur volledig wilt crediteren? Deze actie is niet omkeerbaar. U kunt hieronder ook losse regels crediteren.',
                                onConfirm: close => {
                                    makrAsCredit(null);
                                    close();
                                },
                            })
                        }
                    >
                        Crediteren
                    </Button>
                </div>
            )}
            <Table striped>
                <TableHeader>
                    <TableRow>
                        {canBeCredited && <TableHeaderCell collapsing />}
                        <TableHeaderCell>Omschrijving</TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            Uren/Aantal
                        </TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            Resultaat/Tarief
                        </TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            BTW %
                        </TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            BTW &euro;
                        </TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            Bedrag
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {invoice.lines?.map(line => (
                        <TableRow key={line.id}>
                            {canBeCredited && (
                                <TableCell collapsing>
                                    <Checkbox
                                        checked={selected.includes(line.id)}
                                        onChange={checked =>
                                            setSelected(
                                                checked
                                                    ? [...selected, line.id]
                                                    : selected.filter(
                                                          sel => sel !== line.id
                                                      )
                                            )
                                        }
                                    />
                                </TableCell>
                            )}
                            <TableCell>{line.description}</TableCell>
                            <TableCell textAlign='right'>
                                {line?.extra || '-'}
                            </TableCell>
                            <TableCell textAlign='right'>
                                {formatMoney(line?.amount) || '-'}
                            </TableCell>
                            <TableCell textAlign='right'>{`${line.vat_percentage || 0}%`}</TableCell>
                            <TableCell textAlign='right'>
                                {formatMoney(line.vat) || '-'}
                            </TableCell>
                            <TableCell textAlign='right'>
                                {formatMoney(line.value) || '-'}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        {canBeCredited && <TableCell />}
                        <TableCell colSpan={4} />
                        <TableCell>Subtotaal:</TableCell>
                        <TableCell textAlign='right'>
                            {formatMoney(invoice.subtotal || 0)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {canBeCredited && <TableCell />}
                        <TableCell colSpan={4} />
                        <TableCell>BTW:</TableCell>
                        <TableCell textAlign='right'>
                            {formatMoney(invoice.vat || 0)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {canBeCredited && <TableCell />}
                        <TableCell colSpan={4} />
                        <TableCell>Totaal:</TableCell>
                        <TableCell textAlign='right'>
                            {formatMoney(invoice.total || 0)}
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </>
    );
};

export default InvoiceInfoTable;
